import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register Service Worker for PWA + force update
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
        // Check for updates every 30 minutes
        setInterval(() => registration.update(), 30 * 60 * 1000);
        // Force update on page load
        registration.update();
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
}

// Rechargement automatique quand une nouvelle version est en ligne (Pavel 28/09/2026 :
// la PWA restait sur l'ancien bundle tant qu'on ne la tuait pas). On compare le nom du
// bundle principal servi par le serveur a celui charge ; s'il change, on recharge.
(() => {
  const current = () => {
    const sc = document.querySelector('script[src*="/static/js/main."]');
    const m = sc && (sc.getAttribute('src') || '').match(/main\.([a-z0-9]+)\.js/);
    return m ? m[1] : null;
  };
  let checking = false;
  const check = async () => {
    if (checking || (typeof navigator !== 'undefined' && navigator.onLine === false)) return;
    checking = true;
    try {
      const res = await fetch('/?v=' + Date.now(), { cache: 'no-store' });
      const html = await res.text();
      const m = html.match(/main\.([a-z0-9]+)\.js/);
      const cur = current();
      if (m && cur && m[1] !== cur) window.location.reload();
    } catch (e) { /* hors ligne : rien */ }
    finally { checking = false; }
  };
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') check(); });
  window.addEventListener('focus', check);
  setInterval(check, 5 * 60 * 1000);
  setTimeout(check, 15 * 1000);
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
